<template>
    <svg :class="style" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" fill="currentColor" aria-hidden="true">
        <path d="M44.1,5.9h-15.2c-1.9,0-3.5,1.6-3.5,3.5v31.2c0,1.9,1.6,3.5,3.5,3.5h15.2c1.9,0,3.5-1.6,3.5-3.5V9.4c0-1.9-1.6-3.5-3.5-3.5ZM44.6,9.4v8h-6.6v-8.5h6.1c.3,0,.5.2.5.5ZM38,20.4h6.6v8.5h-6.6v-8.5ZM35,28.9h-6.6v-8.5h6.6v8.5ZM28.9,8.9h6.1v8.5h-6.6v-8c0-.3.2-.5.5-.5ZM28.4,40.6v-8.7h6.6v9.2h-6.1c-.3,0-.5-.2-.5-.5ZM44.1,41.1h-6.1v-9.2h6.6v8.7c0,.3-.2.5-.5.5Z"/>
        <path d="M20.2,5.9h-5.3c-1.9,0-3.5,1.6-3.5,3.5v11.3c0,.8.7,1.5,1.5,1.5s1.5-.7,1.5-1.5v-11.3c0-.3.2-.5.5-.5h5.3c.3,0,.5.2.5.5v31.2c0,.3-.2.5-.5.5h-5.3c-.3,0-.5-.2-.5-.5v-10.2c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5,1.5v10.2c0,1.9,1.6,3.5,3.5,3.5h5.3c1.9,0,3.5-1.6,3.5-3.5V9.4c0-1.9-1.6-3.5-3.5-3.5Z"/>
        <path d="M7.5,27h10.6c.8,0,1.5-.7,1.5-1.5s-.7-1.5-1.5-1.5H7.5l.4-.4c.6-.6.6-1.5,0-2.1s-1.5-.6-2.1,0l-3,3c-.6.6-.6,1.5,0,2.1l3,3c.3.3.7.4,1.1.4s.8-.1,1.1-.4c.6-.6.6-1.5,0-2.1l-.4-.4Z"/>
    </svg>
</template>

<script>
export default {
    props: ['style'],
    setup() {
        
    },
}
</script>